import { Translator } from '@/types/translator.type';

export const HOTEL_CATEGORIES = (t: Translator) => [
  t('hotels.classifications.noStar'),
  t('hotels.classifications.oneStar'),
  t('hotels.classifications.twoStar'),
  t('hotels.classifications.threeStar'),
  t('hotels.classifications.fourStar'),
  t('hotels.classifications.fiveStar'),
  t('hotels.classifications.fiveStarLux'),
  t('hotels.classifications.palace'),
];
